import { render, staticRenderFns } from "./StylePage.vue?vue&type=template&id=77613c65&scoped=true&"
import script from "./StylePage.vue?vue&type=script&lang=js&"
export * from "./StylePage.vue?vue&type=script&lang=js&"
import style0 from "./StylePage.vue?vue&type=style&index=0&id=77613c65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77613c65",
  null
  
)

export default component.exports